// Locale metadata only; this never detects language from a user's text.
export function normalizeWidgetLocale(value) {
  if (typeof value !== 'string' || value.length > 63) return null
  const tag = value.trim()
  if (!tag || ['und', 'mul', 'zxx', 'auto', 'null', 'none'].includes(tag.toLowerCase())) return null
  try {
    const normalized = Intl.getCanonicalLocales(tag)[0] || null
    return normalized?.split('-')[0] === 'it' ? 'it' : normalized
  } catch { /* Intl supports a subset of valid BCP47 tags. */ }
  const grandfathered = ['en-GB-oed', 'i-ami', 'i-bnn', 'i-default', 'i-enochian', 'i-hak', 'i-klingon', 'i-lux', 'i-mingo', 'i-navajo', 'i-pwn', 'i-tao', 'i-tay', 'i-tsu', 'sgn-BE-FR', 'sgn-BE-NL', 'sgn-CH-DE']
  const legacy = grandfathered.find(candidate => candidate.toLowerCase() === tag.toLowerCase())
  if (legacy) return legacy
  // Same tag grammar as the backend; never applied to user conversation text.
  if (!/^(?:(?:[a-z]{2,3}(?:-[a-z]{3}){0,3}|[a-z]{4}|[a-z]{5,8})(?:-[a-z]{4})?(?:-(?:[a-z]{2}|[0-9]{3}))?(?:-(?:[a-z0-9]{5,8}|[0-9][a-z0-9]{3}))*(?:-[0-9a-wy-z](?:-[a-z0-9]{2,8})+)*(?:-x(?:-[a-z0-9]{1,8})+)?|x(?:-[a-z0-9]{1,8})+)$/i.test(tag)) return null
  const parts = tag.toLowerCase().split('-')
  let extension = parts[0] === 'x'
  const singletons = new Set(extension ? ['x'] : [])
  const variants = new Set()
  for (let index = 1; index < parts.length; index++) {
    const part = parts[index]
    if (part.length === 1 && !singletons.has('x')) {
      if (singletons.has(part)) return null
      singletons.add(part); extension = true
    } else if (!extension && /^[a-z]{4}$/.test(part)) parts[index] = part[0].toUpperCase() + part.slice(1)
    else if (!extension && /^[a-z]{2}$/.test(part)) parts[index] = part.toUpperCase()
    else if (!extension && (part.length >= 5 || /^[0-9][a-z0-9]{3}$/.test(part))) {
      if (variants.has(part)) return null
      variants.add(part)
    }
  }
  return parts[0] === 'it' ? 'it' : parts.join('-')
}

export function getInitialWidgetLocale() {
  if (typeof window === 'undefined') return 'it'
  try {
    const host = normalizeWidgetLocale(new URLSearchParams(window.location.search).get('ui_locale'))
    if (host) return host
  } catch { /* Malformed host metadata falls back to the browser locale. */ }
  return normalizeWidgetLocale(window.navigator?.language) || 'it'
}
